/**
 * Minimum trimmed query length before global search does anything — the
 * typeahead fetch, the results-page fetch, and every Enter-submit handler all
 * share this single gate. Two characters: the typeahead has always worked at
 * two, and "AC"/"3M"-style queries are legitimate. Keeping one constant stops
 * the surfaces from disagreeing (submit used to allow 1 char while the results
 * page refused to fetch below 3, navigating users to a guaranteed-empty page).
 *
 * Lives outside `server/search.server.ts` (which is `server-only`) so client
 * submit handlers can import it too.
 */
export const MIN_SEARCH_QUERY_LENGTH = 2
